import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { appResources } from '@/locales';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: appResources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: false,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'bcm_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
